import { render, staticRenderFns } from "./SocialsSlider.vue?vue&type=template&id=8cafbf94&scoped=true&"
import script from "./SocialsSlider.vue?vue&type=script&lang=js&"
export * from "./SocialsSlider.vue?vue&type=script&lang=js&"
import style0 from "./SocialsSlider.vue?vue&type=style&index=0&id=8cafbf94&prod&scoped=true&lang=scss&"
import style1 from "./SocialsSlider.vue?vue&type=style&index=1&id=8cafbf94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cafbf94",
  null
  
)

export default component.exports